module.exports = __webpack_public_path__ + "static/locales/ms.3vDch7c.json";